<template>
    <button class="btn text-left outline-dark border-0 " @click="getMediaUrl()">
        <span :class="iconClass">&nbsp;</span>
        <slot></slot>
    </button>
</template>

<script>
export default {
    name: "OpenMediaUrl",
    props: {
        file: {
            type: Object,
            required: true
        },
        target: {
            type: String,
            required: false
        }
    },
    data () {
      return {
          mediaUrl: null,
      }
    },
    mounted () {

    },
    computed: {
      mediaMimeType: function () {
          return this.file.media[0].mime_type;
      },
        iconClass: function () {
          return this.fileFaIcon();
        },
        targetWindow: function () {
          let target = '_blank';
          if (this.target) {target = this.target}
          return target;
        },
    },
    methods: {
        getMediaUrl: function () {
        axios.get('/api/media-url/' + this.file.id)
            .then(response => {
                this.openMediaUrl(response.data.url);
            })
            .catch(error => {
                // console.log(error);
            })
        },
        openMediaUrl: function (url) {
            return window.open(url, this.targetWindow);
        },
        fileFaIcon: function () {
            let mimeType = this.mediaMimeType;
            let iconClass = '';
            let fileInterjection = 'file-';
            let allowedFileTypes = this.allowedFileTypes();
            if (!allowedFileTypes) {return ''}
            Object.keys(allowedFileTypes).forEach((id, index) => {
                let allowedTypes = allowedFileTypes[id];
                if (allowedTypes.includes(mimeType)) {
                    if (id === 'file') {fileInterjection = ''}
                    iconClass = 'fa fa-' + fileInterjection + id;
                }
            });
            return iconClass;
        },
        allowedFileTypes: function () {
            return {
                image: [
                    'image/bmp',
                    'image/gif',
                    'image/jpeg',
                    'image/png',
                    'image/webp',
                    'image/svg+xml',
                ],
                pdf: [
                    'application/pdf',
                ],
                text: [
                    'text/plain',
                ],
                archive: [
                    'application/zip',
                    'application/gzip',
                    'application/vnd.rar',
                    'application/x-tar',
                ],
                excel: [
                    'application/vnd.ms-excel',
                    'application/vnd.oasis.opendocument.spreadsheet',
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'text/csv',
                ],
                word: [
                    'application/msword',
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                    'application/vnd.oasis.opendocument.text',
                    'application/rtf',
                ],
                powerpoint: [
                    'application/vnd.ms-powerpoint',
                    'application/vnd.oasis.opendocument.presentation',
                    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                ],
                file: [
                    'application/epub+zip',
                ],
            }
        },
    }
}
</script>

<style scoped>

</style>
